<ng-container>
    <div
        class="d-flex h-100"
        id="welcome-banner"
    >
        <div class="widget-image width-400">
            <img
                class="w-85-percent m-t-negative-20 height-p-100 banner-img"
                [src]="themeService.isDarkMode ? 'assets/images/illustrations/banner.svg' : 'assets/images/illustrations/banner-light.svg'"
            />
        </div>
        <div class="banner-info p-t-30">
            <div class="title">
                <div class="fs-17 welcome-title">Welcome to</div>
                <div class="fs-28 main-title">MDR portal</div>
            </div>
            <div class="content m-t-20 w-95-percent">
                Stay informed with the latest news and stories about our products, technology, and innovation!
            </div>
            <button
                (click)="openDoc('new')"
                class="action-button m-t-15"
                id="whats_new_button"
                mat-stroked-button
            >
                WHAT'S NEW
            </button>
            <div class="content m-t-20 w-95-percent">
                Stay up to date with our release notes, your comprehensive guide to the latest features and updates!
            </div>
            <button
                (click)="openDoc('releases')"
                class="action-button m-t-15"
                id="release_notes_button"
                mat-stroked-button
            >
                RELEASE NOTES
            </button>
        </div>
    </div>
</ng-container>
